import React, { Component } from 'react'
import { SelectorCard } from './'

class ManageSchoolsSelectorCard extends Component {
  render() {
    return (
      <SelectorCard>
        <SelectorCard.Header>Manage Schools</SelectorCard.Header>
        <SelectorCard.Instructions>
          Select the school district you want to manage, then click 'Next' to continue.
        </SelectorCard.Instructions>
        <SelectorCard.ProgressBar selectorName={'district'} />
        <SelectorCard.DistrictSelect
          baseLink={'/users/manage/schools/'}
          districts={this.props.districts}
        />
        <SelectorCard.Nav />
      </SelectorCard>
    )
  }
}

export default ManageSchoolsSelectorCard


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManageSchoolsSelectorCard.js